import script from "./WechselVergleich.vue?vue&type=script&setup=true&lang=js"
export * from "./WechselVergleich.vue?vue&type=script&setup=true&lang=js"

import "./WechselVergleich.vue?vue&type=style&index=0&id=33122012&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33122012"]])

export default __exports__